import { Link } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { FloatingRdv } from "./FloatingRdv";
import { MaskLines } from "./Motion";

export const LegalLayout = ({ title, eyebrow, children, testid }) => (
  <div data-testid={testid}>
    <Navbar />
    <main className="bg-[#FAF8F5] pb-28 pt-40 sm:pt-48">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Link to="/" data-testid="legal-back-link" className="link-underline text-sm text-[#3D5A4C]">← Retour à l'accueil</Link>
        <p className="eyebrow mt-10 text-[#3D5A4C]">{eyebrow}</p>
        <h1 className="font-serif-d mt-4 text-5xl font-light leading-tight text-[#1C2826] sm:text-6xl">
          <MaskLines animateOnMount lines={[title]} />
        </h1>
        <div className="legal mt-10 text-[1.02rem]">{children}</div>
      </div>
    </main>
    <Footer />
    <FloatingRdv />
  </div>
);
